import React, { useState } from "react";
import Items from "./MenuData.json";
import SidebarItems from "./sidebarItems";
// import "./sidebar.css";
import "./responsive.css";

import {
  ProSidebar,
  Menu,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";

import "react-pro-sidebar/dist/css/styles.css";
import { useSelector } from "react-redux";


const Aside = ({ handleToggleSidebar }) => {
  // const dispatch = useDispatch();
  const toggled = useSelector((state) => state.AccessTocken.sidebarToggle);

  const [showFooter, setShowFooter] = useState(true);

  const year = new Date().getFullYear();

  // const totalWidth = Math.round(window.innerWidth / 12) * 2;

  //const widthPer = (totalWidth / window.innerWidth) * 100;
  return (
    <div
      style={{
        height: "91vh",

        overflowY: "none !important",
      }}
    >
      <ProSidebar
        // rtl={rtl}
        id="sidebar"
        toggled={toggled}
        breakPoint="md"
        onToggle={handleToggleSidebar}
      >
        {!showFooter ? (
          <SidebarContent
            style={{
              marginBottom: "220px",
              // width: "10px !important",
            }}
          >
            <Menu>
              {Items.map((item, index) => (
                <SidebarItems key={index} item={item} />
              ))}
            </Menu>
           
          </SidebarContent>
        ) : (
          <SidebarContent
            style={{
              marginBottom: "0px",
              // width: "50px !important",
            }}
          >
            <Menu>
              {Items.map((item, index) => (
                <SidebarItems key={index} item={item} />
              ))}
            </Menu>
            <div style={{ height: "50px" }}></div>
          </SidebarContent>
        )}

        {showFooter ? (
          <SidebarFooter>
            <div
              className="sidebar-btn-wrapper"
              style={{
                padding: "8px ",
                height: "6vh",
              }}
            >
              <div className="d-flex justify-content-between">
                <div
                  className="p-0"
                  style={{ fontSize: "12px", whiteSpace: "nowrap",color:"black" }}
                >
                  Powered by <strong style={{color:"#3d86c6"}}>TATA ELXSI</strong>
                </div>

                <div
                  className="p-0 ms-3 animateThis"
                  onClick={() => setShowFooter(!showFooter)}
                >
                  {!showFooter ? (
                    <i className="bi bi-arrow-down-circle-fill"></i>
                  ) : (
                    <i className="bi bi-arrow-up-circle-fill"></i>
                  )}
                  {!showFooter && <div style={{ height: "200px" }}></div>}
                </div>
              </div>
            </div>
          </SidebarFooter>
        ) : (
          <SidebarFooter>
            <div
              className="sidebar-btn-wrapper"
              style={{
                padding: "8px ",
                height: "36vh",
              }}
            >
              <div className="d-flex justify-content-between">
                <div
                  className="p-0"
                  style={{ fontSize: "12px", whiteSpace: "nowrap",color:"black" }}
                >
                  Powered by <strong style={{color:"#3d86c6"}}>TATA ELXSI</strong>
                  <div className="d-flex justify-content-center">
                    {!showFooter && (
                      <div
                        style={{
                          height: "400px",
                          fontSize: "12px",
                        }}
                      >
                        <br />
                        <span
                          className="d-flex flex-column"
                          style={{ width: "150px" }}
                        >
                          <p>{`Copyright © ${year}`}</p>
                          <p>TATA ELXSI</p>
                          <p>CMS site</p>
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className="p-0 ms-3 "
                  onClick={() => setShowFooter(!showFooter)}
                >
                  {!showFooter ? (
                    <i className="bi bi-arrow-down-circle-fill"></i>
                  ) : (
                    <i className="bi bi-arrow-up-circle-fill"></i>
                  )}
                </div>
              </div>
            </div>
          </SidebarFooter>
        )}
      </ProSidebar>
    </div>
  );
};

export default Aside;
